import type { ReactElement } from 'react';
import { useState } from 'react';

import { Component as CloseIcon } from 'icons/icon-ui--close.svg';
import { Component as ErrorIcon } from 'icons/icon-circle--error.svg';
import Modal from 'components/shared/Modal';

type Props = {
  message: string;
  title?: string;
  onClose?: () => void
};

function ErrorModal({
  message,
  title = 'Error',
  onClose,
}: Props): ReactElement {
  const [show, setShow] = useState(true);

  return (
    <Modal
      show={show}
      className="modal-dialog-centered"
      wrapperClassName="c-modal-error"
      onClose={onClose}
      body={(
        <>
          <button
            className="close"
            type="button"
            aria-label="Close modal"
            style={{ padding: 0, border: 0 }}
            onClick={() => {
              setShow(false);
              if (onClose) onClose();
            }}
          >
            <CloseIcon width="32" height="32" />
          </button>

          <div className="c-modal-error__content">
            <ErrorIcon />
            <h3 className="c-heading c-heading--brand-4">
              {title}
            </h3>
            <div>
              {message}
            </div>
          </div>
        </>
      )}
    />
  );
}

export default ErrorModal;
